import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../Baseurl";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";

const AboutUs = () => {
  const [terms, setTerms] = useState("");

  // Fetch terms from API
  const fetchTerms = async () => {
    try {
      const response = await axios.get(`${baseurl}getAbout`);
      if (response.data.data) {
        setTerms(response.data.data.data); // Set terms data
      }
    } catch (error) {
      console.error("Error fetching terms:", error);
    }
  };

  // Fetch terms on component mount
  useEffect(() => {
    fetchTerms();
  }, []);

  return (
    <>
      <VisitorNavbar />

      <div className="about-container">
        <div className="about-banner-wrapper">
          <div className="about-banner-content">
            <div className="about-banner-text">
              <p className="subheading">Your Trusted Partner</p>
              <h1>Advanced Lab Equipment Solutions</h1>
              <p className="tagline">
                Delivering precision, innovation, and reliability to
                laboratories worldwide.
              </p>
              <button className="cta-button">Discover More</button>
            </div>
            <div className="about-banner-image">
              <img
                src="https://backend.techsparesindia.com/uploads/banners/1742636452588.jpeg"
                alt="Lab Equipment"
              />
            </div>
          </div>
        </div>

        {/* 🔽 Section with Text Left, Image Right */}

        <div className="about-yellow-section">
          <div className="about-yellow-image">
            <img
              src="https://backend.techsparesindia.com/uploads/banners/1744189000277.png"
              alt="Laboratory Equipment"
            />
          </div>

          <div className="about-yellow-text">
            <h2>Who We Are?</h2>
            <p>
              At Tech Spares India, we believe in the concept that one person's
              waste can be another person's treasure. With over 20 years of
              experience in the equipment field and operating a successful
              testing laboratory, we have witnessed firsthand the vast amounts
              of equipment that go unused, sitting idle in laboratories across
              the country. We understand that every piece of equipment has
              potential value, and that’s where we come in.
              <br></br>
              <br></br>
              Welcome to TechSpares India – your trusted partner in quality
              components, innovative solutions, and reliable service. At
              TechSpares, we believe in empowering businesses and individuals
              with access to the finest spare parts, tools, and technology. From
              analytical instruments to industrial automation and beyond, we
              bridge the gap between demand and supply with integrity, speed,
              and precision.
            </p>
          </div>
        </div>

        {/* Mission & Vision */}
        <section className="mission-vision-container">
          <div className="info-card">
            {/* <img src={mission} alt="Mission Icon" /> */}
            <h3>MISSION</h3>
            <p>
              Our mission is to create a sustainable platform that connects
              those who have surplus laboratory equipment with those who need
              it. It doesn’t matter if you’re upgrading, downsizing, or simply
              decluttering; we provide a convenient and efficient way for you to
              find a new home for your unused items. By doing so, not only do we
              reduce waste, but we also help others access quality equipment at
              affordable prices. For instance, consider the common scenario
              where a laboratory no longer requires a 0.01mg balance due to
              changing requirements, while another lab desperately seeks a 0.1mg
              balance for their research. By facilitating this exchange, we
              ensure that valuable items remain in circulation, benefiting both
              parties and enhancing the utility of resources.
            </p>
          </div>

          <div className="info-card">
            {/* <img src={vision} alt="Vision Icon" /> */}
            <h3>VISION</h3>
            <p>
              TechSparesIndia.com is more than just a marketplace; it’s a
              community of like-minded individuals committed to maximizing the
              potential of laboratory equipment while promoting sustainability.
              Join us in our mission to give your unused equipment a second
              life, and help someone else in the process. Together, we can turn
              waste into valuable resources and foster a culture of reuse. Thank
              you for visiting TechSparesIndia.com, where sustainability meets
              innovation. Let’s work together to create a smarter, more
              resourceful future.
              <br></br>
              Feel free to modify any part of this text to better match your
              vision and values!
            </p>
          </div>
        </section>
      </div>

      {/* <div className="container mt-4"> 
      <div className="card text-start p-4 mb-4">
        {terms ? (
          <div dangerouslySetInnerHTML={{ __html: terms }} />
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </div> */}
      <Footer />
    </>
  );
};

export default AboutUs;
